import React from "react";
import "./App.css";
// import "./sectionStyles/Footer.css";

function Footer() {
  return (
    <div className="Footer">
      <footer>© 2021 Talia Bahar</footer>
    </div>
  );
}

export default Footer;

{
  /* <div
className="footer"
//   style={{
//     position: "fixed",
//     left: 0,
//     bottom: "0",
//     width: "100%",
//     textAlign: "center",
//   }}
> */
}
